module.exports = __webpack_public_path__ + "images/dc02b8534d13a79e6fe6e21c3fcc6768-logo.png";